import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type InvitationResendFailedAction = {
	type: 'INVITATION_RESEND_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): InvitationResendFailedAction => ({
	type: 'INVITATION_RESEND_FAILED',
	payload,
});
